import script from "./ConfirmationView.vue?vue&type=script&lang=ts&setup=true"
export * from "./ConfirmationView.vue?vue&type=script&lang=ts&setup=true"

import "./ConfirmationView.vue?vue&type=style&index=0&id=4d36ad66&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d36ad66"]])

export default __exports__